import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StyledLeafletHeader } from '../styles';
import { ICON_PATH, IMAGE_ROOT, IS_LEAFLET_TYPE } from 'src/utils/constants';
import { appStoreMove } from 'src/utils/leaflet';
import { leafletGaEvent } from 'src/utils/ga';
import { isMobile } from 'react-device-detect';

type TProps = {
  onClose?: () => void; // 마트고 앱 내 팝업 닫기용
};
/**
 * @name 전단상세 헤더
 */
function LeafletHeader(props: TProps): React.ReactElement {
  const navigate = useNavigate();
  const pageName = '전단헤더';

  // 전단 허브로 가기
  const handleClickMain = () => {
    leafletGaEvent(pageName, '메인으로가기');
    if (IS_LEAFLET_TYPE) {
      navigate('/leaflet/hub', { replace: true });
    } else {
      navigate('/');
    }
  };
  // 전단 닫기
  const handleClickCloseBtn = () => {
    if (props.onClose) {
      leafletGaEvent(pageName, '전단팝업닫기');
      props.onClose();
    }
  };
  // APP 다운받기
  const handleClickDownApp = () => {
    leafletGaEvent(pageName, 'APP다운받기');
    // 앱 전단으로 이동
    const url = `${process.env.REACT_APP_GO_URL}/leaflet?leafletWv_yn=Y&hfrom=APP&rst1=J`;
    appStoreMove(url);
  };

  return (
    <StyledLeafletHeader>
      <button className="list_icon" onClick={handleClickMain}>
        전단 목록 보기
      </button>
      {IS_LEAFLET_TYPE && (
        <button className="close_icon" onClick={handleClickCloseBtn}>
          <img src={`${ICON_PATH}/icon_close.png`} alt="전단 닫기" />
        </button>
      )}
      {!IS_LEAFLET_TYPE && isMobile && (
        <button className="app_icon" onClick={handleClickDownApp}>
          <img
            src={`${IMAGE_ROOT}/leaflet/common/leaflet_common_appBtn.png`}
            alt="앱 다운받기"
          />
        </button>
      )}
    </StyledLeafletHeader>
  );
}

export default LeafletHeader;
